import { render, staticRenderFns } from "./UserDeletionModal.vue?vue&type=template&id=6aa0d252&scoped=true&"
import script from "./UserDeletionModal.vue?vue&type=script&lang=js&"
export * from "./UserDeletionModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aa0d252",
  null
  
)

export default component.exports